import { WEB_LOGIN, WEB_LOGOUT, SET_ORDER_TYPES, SET_TABLE_ORDERS } from '../action-types/session-actions';

const initState = {
    isAuthented: false,
    token: null,
    store_id: null,
    location_id: null,
    tent_id: null,
    table_details: null,
    store_details: null,
    store_config: null,
    order_types: [],
    is_fsr: false,
    associated_stores: [],
    table_orders: null,
};

const reducer = (state = initState, action) => {
    switch (action.type) {
        case WEB_LOGIN: {
            return {
                ...state,
                isAuthented: true,
                token: action.payload.token,
                store_id: action.payload.store_id,
                location_id: action.payload.location_id,
                tent_id: action.payload.tent_id || null,
                table_details: action.payload.table_details || null,
                store_details: action.payload.store_details || null,
                store_config: action.payload.store_config || null,
                is_fsr: action.payload.is_fsr === true,
                associated_stores: Array.isArray(action.payload.associated_stores)
                    ? action.payload.associated_stores
                    : [],
            };
        }
        case SET_ORDER_TYPES: {
            return { ...state, order_types: action.order_types };
        }

        
        case 'STORE_DETAILS':
        case 'GET_STORE_DETAILS':
            return { ...state, store_details: action.storeInfo };
        case 'STORE_CONFIG':
        case 'GET_STORE_CONFIG':
            return { ...state, store_config: action.storeInfoConfig };
        case 'ASSOCIATED_STORES':
            return { ...state, associated_stores: action.associated_stores };
        case 'CLEAR_ASSOCIATED_STORE':
            return { ...state, associated_stores: [] };
        case SET_TABLE_ORDERS:
            return { ...state, table_orders: action.table_orders };
        case WEB_LOGOUT: {
            return { ...initState };
        }
        default: {
            return { ...state };
        }
    }
};

export default reducer;
